var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewcampaignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15.49 13.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#1c3152;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 15.49,
    height: 13.22
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.3,11.83a1.13,1.13,0,0,1-1-.66A1.16,1.16,0,0,1,.43,9.91L.5,9.83l.71-.71a5.29,5.29,0,0,1-1-2.78V6C.16,2.71,3.12.14,6.9.14S13.64,2.71,13.64,6s-2.89,5.77-6.58,5.84ZM6.9,1.14C3.73,1.14,1.16,3.32,1.16,6v.29a4.36,4.36,0,0,0,1,2.51l.3.35-.28.38-1,1a.2.2,0,0,0,0,.21.13.13,0,0,0,.13.08H7.05c3.13-.06,5.59-2.19,5.59-4.84S10.06,1.14,6.9,1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.24,10.41a5.17,5.17,0,0,0,1.12-2.83V7.23a5.88,5.88,0,0,0,0-.6.44.44,0,0,0-.17-.3.45.45,0,0,0-.32-.09.42.42,0,0,0-.29.17.41.41,0,0,0-.09.32,4,4,0,0,1,0,.49v.3a4.37,4.37,0,0,1-1.13,2.58l-.33.37,1.41,1.35a.24.24,0,0,1,0,.24.25.25,0,0,1-.23.15h-6a.44.44,0,0,0,0,.88h6a1.14,1.14,0,0,0,1-.66,1.11,1.11,0,0,0-.2-1.21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewcampaignIcon);
export default __webpack_public_path__ + "static/media/newcampaign-icon.cc768af1e81b66ee260b4bfa83eaf94a.svg";
export { ForwardRef as ReactComponent };